import VirtualList, { IChildrenProps as IVirtualListChildrenProps, TVirtualListRef } from './VirtualList';

export type { IVirtualListChildrenProps, TVirtualListRef };
export default VirtualList;
